import AcceptReject from './container';

export default AcceptReject;
